import * as React from "react";
import Component from "../../AbstractComponent";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import { ChargeTemplate } from "../../../Entity/Entities/Charge/ChargeTemplate";
import ChargeTemplateFactory from "../../../Entity/Factories/ChargeTemplateFactory";
import Button from '@material-ui/core/Button';
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";

export default class Charge2DetailsReadonly extends Component {
	public state = {
		isChargeTemplateRemovePopupOpen: false
	};

  constructor(public props) {
    super(props);
	}
	
  public render() {
    const chargeTemplate: ChargeTemplateInterface = this.props.chargeTemplate instanceof ChargeTemplate ? this.props.chargeTemplate : ChargeTemplateFactory.create(this.props.chargeTemplate);

		let title = "";

		if (chargeTemplate?.isDefault) {
			title = !chargeTemplate?.isPayable ? this.trans("receivable-template") : this.trans("payable-template");
		} else {
			if (chargeTemplate?.contractId) {
				title = !chargeTemplate?.isPayable ? this.trans("receivable-template") : this.trans("payable-template");
			} else {
				title = !chargeTemplate?.isPayable ? this.trans("receivable-template") : this.trans("payable-template");
			}
		}
		
		return (
			<div className="charge-details-readonly">
				{/* <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
					<div style={{display: "flex", alignItems: "baseline"}}>
						<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
            {title}
						</div>
					</div>
					<div className="date">
						{this.formatter.formatDate(chargeTemplate?.dueDateFirstPayment)}
					</div>
				</div> */}
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
					<div className="counterparty" style={{fontWeight: "bold", color: "#000000"}}>
          {this.formatter.checkTranslationType(this.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)}
						{/* {chargeTemplate?.counterparty?.displayName || ""} */}
            <span className="counterparty"> {title}</span>
					</div>
					<div style={{display: "flex", flexDirection: "column", justifyContent: "flex-end", alignItems: "flex-end", position: "relative"}}>
						<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
							<div className="currency">
								{chargeTemplate?.currency?.getIso?.()}
							</div>
							<div className="amount">
								{this.props.chargeTemplate instanceof ChargeTemplate ? this.formatter.formatNumber(chargeTemplate?.amount) : this.formatter.simpleFormatNumber(chargeTemplate?.amount, false)} 
							</div>
						</div>	
						{
							chargeTemplate?.isPaidDirectlyToOwner && (
								<div style={{position: "absolute", top: "28px"}}>
									<div className="list-label creation-type-label">
										{this.trans("label-direct")}
									</div>
								</div>
							)
						}
					</div>					
				</div>
				<div style={{display: "flex", justifyContent: "space-between"}}>
					<table>
						{/* <tr>
							<td className="align-left first-column">
								{`${this.trans("dialog/defaultchargetemplates-field/type-label")}:`}
							</td>
							<td className="align-left">
								{this.formatter.checkTranslationType(this.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)}
							</td>
						</tr> */}
						<tr>
							<td className="align-left first-column">
								{`${this.trans("dialog/defaultchargetemplates-field/period-label")}:`}
							</td>
							<td className="align-left">
								{this.formatter.checkTranslationType(this.trans(chargeTemplate?.repeatPeriod?.label), chargeTemplate?.repeatPeriod?.label)}
							</td>
						</tr>
						{/* {
							chargeTemplate?.firstDate && (
								<tr>
									<td className="align-left first-column">
										{`${this.trans("first-date")}:`}
									</td>
									<td className="align-left">
										{this.formatter.formatDate(chargeTemplate?.firstDate)}
									</td>
								</tr>
							)
						}
						{
							chargeTemplate?.endDate && (
								<tr>
									<td className="align-left first-column">
										{`${this.trans("end-date")}:`}
									</td>
									<td className="align-left">
										{this.formatter.formatDate(chargeTemplate?.endDate)}
									</td>
								</tr>
							)
						} */}
						{/* {
							chargeTemplate?.description && (
								<tr>
									<td className="align-left first-column">
										{`${this.trans("description")}:`}
									</td>
									<td className="align-left">
										{chargeTemplate?.description}
									</td>
								</tr>
							)
						} */}
					</table>
				</div>
				<div style={{marginTop: "10px", display: "flex", justifyContent: "space-between"}}>
					<Button 
						variant="outlined"
						color="primary"
						onClick={() => {
							if (typeof this.props.openChargeTemplate === "function"){
								this.props.openChargeTemplate.call(this, chargeTemplate)
							}
						}}
					>
						{this.trans("button-open")}
					</Button>
					<Button 
						variant="outlined"
						style={{color: "#F44336", borderColor: "#F44336"}}
						onClick={() => {
							this.setState({
								isChargeTemplateRemovePopupOpen: true
							});
						}}
					>
						{this.trans("button-remove")}
					</Button>
				</div>

				<DeleteEntityPrompt
          {...this.props}
          entityName={"dialog/preprocess-info/deletechargetemplate"}
          isOpen={this.state.isChargeTemplateRemovePopupOpen}
          onCancel={() => {
						this.setState({
							isChargeTemplateRemovePopupOpen: false
						});
					}}
          onDelete={() => {
						this.setState({
							isChargeTemplateRemovePopupOpen: false
						});
						if (typeof this.props.removeChargeTemplate === "function"){
							this.props.removeChargeTemplate.call(this, chargeTemplate)
						}
					}}
        />
			</div>
		);
  }
}
